import React from "react";

import type { BaseProps, CardTitleHeaderLevels } from "../../../lib/modules/listSearchUtils/index.d";

function CardTitleHeader({
  title,
  korttittel,
  groupBy,
  headerLevel = "h2"
}: Readonly<Pick<BaseProps, "title" | "korttittel" | "groupBy">>
  & { headerLevel?: CardTitleHeaderLevels}) {
  const displayTitle = korttittel || title;
  if (!displayTitle) return null;

  const baseClass = "line-clamp-2";

  if (groupBy) {
    // data-toc-ignore used to make sure title is not dispayed in part "helsecoreTableOfContent"
    return <h2 data-toc-ignore className={`${baseClass} text-xl`}>{displayTitle}</h2>;
  }

  if (headerLevel === "h4") {
    return <h4 data-toc-ignore className={`${baseClass}`}>{displayTitle}</h4>;
  }

  if (headerLevel === "h3") {
    return <h3 data-toc-ignore className={`${baseClass}`}>{displayTitle}</h3>;
  }

  return <h2 data-toc-ignore className={`${baseClass} text-xl`}>{displayTitle}</h2>;
}

export default CardTitleHeader;
